import React, { useState } from 'react';
import AircraftTypes from '../Form/AircraftTypes';
import CharterType from '../Form/CharterType';

import DangerousGoods from '../Form/DangerousGoods'
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import FlightRoute from './FlightRoute';

import { FormLabel } from '../Form/FormLabel';
import { ErrorMessage, useFormikContext } from 'formik';
import { endpoints } from '../../utils/Constants';
import SelectCurrency from '../Form/SelectCurrency';
import Inexclusions from "../Form/Inexclusions";
import { useAuth } from '../../Services/AuthContext';
import { showDateTimeUTC } from '../../utils/Helpers';

import { FormGroup, Button, Row, Col } from 'reactstrap';
import SelectSetting from '../Form/SelectSetting';
import CompareFormValue from '../Form/CompareFormValue';
import useCheckMobileScreen from '../../utils/Hooks/useCheckMobileScreen';
import { useFetchCached } from '../../Services/fetchApi';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useEdit } from '../../Services/EditContext';

import RoutesSummary from './RoutesSummary';
import FlightTimeSummary from './FlightTimeSummary';
import { FormValue } from '../Form/FormLabel';
import Card from 'react-bootstrap/Card'
import FormTextArea from '../Form/FormTextArea';
import SupplierSelector from '../Form/SupplierSelector';

const BidDetail = (props) => {
    const { route, newRequest, compare, noEdit, supplierId } = { ...props };
    const [auth] = useAuth();
    const { values } = useFormikContext();
    const supplierChange = compare && (values.supplierInitiated || values.status === "Pending Supplier");
    const clientChange = compare && (!values.supplierInitiated && values.status !== "Pending Supplier");
    const isMobile = useCheckMobileScreen();
    const [edit] = useEdit();

    const [charterTypes, loadingCharterTypes, errorCharter] = useFetchCached(endpoints.getCharterType);
    const placeBid = values.bid ? true : false;
    return (<React.Fragment>
        <Row>
            <Col>
                <Card>
                    <Card.Header style={{
                        fontSize: "1.25rem", fontWeight: "bolder", paddingTop: "0.1em",
                        height: "2em", backgroundColor: "#428bca", color: "#fff"
                    }}>
                        <Row>
                            <Col>
                                Supplier Details
                            </Col>
                            <Col style={{ textAlign: "right" }} >
                                <SupplierSelector route={route} id='bidderId' name='bidderId' isClientView={true} charterRequestId={values.charterRequestId} />
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body style={{ paddingBottom: "0.2em" }}>
                        <Row>
                            <Col xs='6' md='3'>
                                <FormLabel style={{ display: 'block' }}>Name</FormLabel>
                                <FormValue>{values.supplier?.companyName ?? 'Supplier removed'}</FormValue>
                            </Col>
                            <Col xs='6' md='3'>
                                <FormLabel style={{ display: 'block' }}>Status</FormLabel>
                                <FormValue>{values.supplier?.status}</FormValue>
                            </Col>
                            <Col xs='6' md='3'>
                                <FormLabel style={{ display: 'block' }}>Phone Number</FormLabel>
                                <FormValue>{values.supplier?.companyPhone}</FormValue>
                            </Col>

                            <Col xs='8' md='3'>
                                <FormLabel style={{ display: 'block' }}>Email</FormLabel>
                                <FormValue>{values.supplier?.email}</FormValue>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </Col>
        </Row>

        <Row>
            <Col>
                <AircraftTypes compare={compare} id='preferredAircraft' label='Preferred Aircraft' list={charterTypes?.aircraftTypes} noEdit={noEdit || supplierChange} />
            </Col>

        </Row>
        {!newRequest && (values.specialRequests || clientChange) ? <FormTextArea id='specialRequests' label='Special Requests' type='textarea' noEdit={!clientChange && (noEdit || supplierChange || placeBid)} /> : null}
        <CharterType placeBid={placeBid} supplierChange={supplierChange} compare={compare} charterTypes={charterTypes} noEdit={noEdit || supplierChange} />
        {values.status === "Confirmed" || values.status === "Finished" ? <FlightTimeSummary /> : null}
        {auth.role === "Admin" && values.routes instanceof Array ? <RoutesSummary /> : null}
        {loadingCharterTypes ? <LoadingAnimation height={50} /> : null}
        {errorCharter ? <h6>Error Loading Charter Types</h6> : null}
        <FlightRoute noEdit={noEdit} placeBid={placeBid} newRequest={newRequest} compare={compare} />

        <Row>
            {newRequest || values?.status === "Live" || values?.status === "Pending" ? <Col md='4' xs='4'>
                {(edit && !noEdit) || newRequest || values?.urgent ? <BooleanInput style={!newRequest && !edit && !noEdit ? { color: 'red' } : {}} id='urgent' label='Urgent - within 24 hours' noEdit={noEdit} /> : null}
            </Col> : null}

        </Row>

        {placeBid || supplierChange ? <React.Fragment>

            {placeBid || supplierChange || values.notes ? <FormTextArea compare={compare} id='notes' label='Notes for customer' type='textarea' noEdit={clientChange} /> : null}

            {!isMobile ? <Row>
                <Col md='3' xs='6'>
                    <SelectSetting endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
                </Col>
                <Col md='3' xs='6'>
                    <Inexclusions noEdit={clientChange} />
                </Col>
                <Col md='3' xs='6'>
                    <SelectCurrency id='currency' label='Currency' noEdit={clientChange} />
                </Col>
                <Col md='3' xs='6'>
                    <Col >
                        <FormInput id='price' label='Price (EX GST)' type='number' currency min={0} noEdit={clientChange} />
                    </Col>
                    {auth.role === 'Admin' && values.withMargin ? <Col>
                        <FormGroup><FormLabel style={{ display: 'block' }}>{'With Margin'}</FormLabel>
                            <ErrorMessage name={'withMargin'} />
                            <CompareFormValue id='withMargin' type='currency' style={{ display: 'block' }} />
                        </FormGroup>
                    </Col> : null}
                </Col>

            </Row> : <React.Fragment><Row>
                <Col md='3' xs='6'>
                    <SelectSetting endpoint={endpoints.getSettings + 'Catering'} id='catering' label='Catering' />
                </Col>
                <Col md='3' xs='6'>
                    <Inexclusions noEdit={clientChange} />
                </Col>
            </Row><Row>
                    <Col md='3' xs='6'>
                        <SelectCurrency id='currency' label='Currency' noEdit={clientChange} />
                    </Col>
                    <Col md='3' xs='6'>
                        <Col >
                            <FormInput id='price' label='Price (EX GST)' type='number' currency min={0} noEdit={clientChange} />
                        </Col>
                        {auth.role === 'Admin' && values.withMargin ? <Col>
                            <FormGroup><FormLabel style={{ display: 'block' }}>With Margin</FormLabel>
                                <ErrorMessage name={'withMargin'} />
                                <CompareFormValue id='withMargin' type='currency' style={{ display: 'block' }} />

                            </FormGroup>
                        </Col> : null}
                    </Col>

                </Row>
            </React.Fragment>}


        </React.Fragment> : null}
        <DangerousGoods compare={compare} dangerousGoodsList={charterTypes?.dangerousGoods} noEdit={noEdit || supplierChange} />
        {values.biddingEndsAt ? < div style={{ fontSize: 'small' }}>Bidding Ends At:{showDateTimeUTC(values.biddingEndsAt)}</div> : null}
    </React.Fragment>)
};

export default BidDetail;
